import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

import AuthenticationService from '../service/AuthenticationService';
import EventBus from "../common/EventBus";
import CompanyService from '../service/CompanyService';
//import { useHistory } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import utils from '../constants/utils';
import AccountService from '../service/AccountService';
import AuthService from '../security/AuthService';
import PasswordChecklist from "react-password-checklist"
import Constants from '../constants/Constants';
import { InputTextarea } from 'primereact/inputtextarea';
import { set } from 'date-fns';

const CustomEditProfile = (props) => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [description, setDescription] = useState("");
    const [contacts, setContacts] = useState([]);
    const [contact, setContact] = useState("");
    const [newID, setNewID] = useState(-1);

    let { usermail, verificationToken, action } = useParams();
    console.log("CustomEditProfile usermail: ", usermail, " verificationToken: ", verificationToken);

    console.log("CustomEditProfile props: ", props);


    const [checkApprove, setCheckApprove] = useState(true);



    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }



    useEffect(() => {
        console.log("CustomEditProfile useEffect", props?.profileInfo);
        if (props?.profileInfo?.details?.description?.length > 0)
            setDescription(props?.profileInfo?.details?.description[0].val);
        if (props?.profileInfo?.details?.contacts?.length > 0)
            setContacts(props?.profileInfo?.details?.contacts);
    }, [props?.profileInfo]);

    useEffect(() => {

    }, [contacts]);



    const checkContact = () => {
        let _contacts = contacts;

        let _newId = newID - 1;
        setNewID(_newId);

        if (!_contacts?.length > 0) {

            _contacts = [];
        }


        let _id = parseInt(_newId);

        console.log("addContactSite _id", _id, contacts, _newId);

        let _val =contact;
        if (!(_val.startsWith("http://") || _val.startsWith("https://"))) {
            _val= "https://" + _val;
        }

        let _contact = { id: '' + _id, val: _val, key: "contacts" };
        return _contact;
    }


    const addContactSite = (param) => {

        if (contact?.length === 0) return;

        let _contact = checkContact();
       
        console.log("addContactSite", _contact, contacts);
        setContacts([...contacts, _contact]);
        setContact("");

    }
    const removeContactSite = (param) => {
        console.log("removeContactSite", param);
        setContacts(
            contacts.filter(a => a.id !== param.id)
        );
    }

    const updateContact = (param,contact) => {
        console.log("updateContact", param,contact);
        let _contact=[];
        contacts.forEach(key => {
            if(key.id===contact.id){
                key.val=param;
            }
            _contact.push(key);

        });
        setContacts(_contact);
        


    }




    const onCancelEdit = () => {
        props.onEditClear();

    }
    const onSave = () => {
        let _profileInfo = props.profileInfo;
        let _description = { id: '1', val: description, key: "description" };
        if (_profileInfo.details?.description?.length > 0) {
            _profileInfo.details.description[0].val = _description;
        } else {
            _profileInfo.details.description = [];
            _profileInfo.details.description.push(_description);
        }
        _profileInfo.details.description[0].val = description;

        let _contacts = contacts;
        console.log("onSave 1 _contacts contact",_contacts,contact);

        if (contact?.length > 0) {
            let _contact=checkContact();
            _contacts =  [...contacts, _contact];

        }
        console.log("onSave _contacts contact",_contacts,contact);

        _profileInfo.details.contacts =_contacts;

        console.log("onSave", _profileInfo);
        props.onSave(_profileInfo);
    }

    const renderContacts = (params) => {


        return (
            params?.map((param, index) => {

                return (
                    <div key={index} className="col-12 md:col-12">
                        <div className='flex justify-content-between w-12'>

                            <Button icon="fas fa-minus" className="p-button-rounded p-button-header mr-2 mb-2"
                                onClick={(e) => { removeContactSite(param); }}
                            />

                            <InputText value={param.val} onChange={(e) => updateContact(e.target.value,param)} 
                                className="inputtext_raunded p-inputtext w-12" type="text" placeholder={t('global_text_profile_contact')}></InputText>

                        </div>

                    </div>
                )
            })
        )



    }
    const renderProfileInfo = () => {
        console.log("renderProfileInfo", contacts);
        if (props.profileInfo) {
            return (
                <div className="grid p-2 w-12">
                    {renderContacts(contacts)}
                    {contacts?.length < 5 &&
                        <div className="col-12 md:col-12">
                            <div className='flex justify-content-between w-12'>
                                <Button icon="pi pi-plus" className="p-button-rounded p-button-header mr-2 mb-2"
                                    onClick={(e) => { addContactSite(e.target.value); }}
                                />

                                <InputText value={contact} onChange={(e) => setContact(e.target.value)}
                                    className="inputtext_raunded p-inputtext w-12" type="text" placeholder={t('global_text_profile_contact')}></InputText>
                            </div>
                        </div>
                    }

                    <div className="col-12 md:col-12">
                        <InputTextarea value={description} onChange={(e) => setDescription(e.target.value)}
                            className="inputtext_raunded p-inputtext w-12 p-4"
                            rows={10} cols={30} autoResize  maxLength={1000}/>
                    </div>
                    <div className=" flex  pr-3 pb-3 w-12 justify-content-end font-600-regular">
                        {description.length +" / 1000"}
                    </div>
                </div>

            )
        }
    }


    const renderButton = () => {


        return (
            <div className=" flex  pr-3 pb-3 w-12 justify-content-end">
                <Button label={t('global_text_cancel_edit')} className="p-button-rounded  p-button-secondary mr-2 mb-2 " text
                    onClick={() => onCancelEdit()}></Button>

                <Button label={t('global_btn_save')} className="p-button-rounded mr-2 mb-2 pr-3 pl-3"

                    onClick={() => onSave()}></Button>
            </div>
        )

    }
    return (
        <div className="flex justify-content-between  flex-column" >
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>

            {renderProfileInfo()}

            {renderButton()}


        </div>
    )
}

export default CustomEditProfile;